import "./About.module.css";
import Navigation from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import NomocoStudies from "./sections/NomocoStudies";
import Research from "./sections/Research";
import Biography from "./sections/Biography";
import InstitutionsGrid from "./sections/InstitutionsGrid";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Navigation />
      <Mission />
      <Biography />
      <NomocoStudies />
      <Research />
      <InstitutionsGrid />
      <Footer />
    </div>;
}